// Dev-only position override for "?fake=1", so navigation can be demoed
// (e.g. in Meta's display simulator, which has no real GPS) without a
// server or a real geolocation fix: "?lat=&lng=" stands in for the player's
// position once location starts (granted automatically, or a tap on the fallback button).
export interface SimulatedFix {
  lat: number;
  lng: number;
}

function parseNumber(text: string | null): number | null {
  if (text === null || text.trim() === '') return null;
  const n = Number.parseFloat(text);
  return Number.isFinite(n) ? n : null;
}

export function parseSimulatedFix(search: string): SimulatedFix | null {
  const q = new URLSearchParams(search);
  // A fixed position replaces real GPS only in an explicit demo (demoLocation=1,
  // or the desk demo's fake=1). A stray lat/lng on a real walk must not
  // silently switch the phone's GPS off.
  if (q.get('demoLocation') !== '1' && q.get('fake') !== '1') return null;
  const lat = parseNumber(q.get('lat'));
  const lng = parseNumber(q.get('lng'));
  if (lat === null || lng === null) return null;
  return { lat, lng };
}

/** "?heading=" for a desk demo with no compass: degrees from true north. */
export function parseSimulatedHeading(search: string): number | null {
  return parseNumber(new URLSearchParams(search).get('heading'));
}
